import { render } from "./HeaderLayout.vue?vue&type=template&id=288eaad1"
import script from "./HeaderLayout.vue?vue&type=script&lang=js"
export * from "./HeaderLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/student-package/HeaderLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "288eaad1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('288eaad1', __exports__)) {
    api.reload('288eaad1', __exports__)
  }
  
  module.hot.accept("./HeaderLayout.vue?vue&type=template&id=288eaad1", () => {
    api.rerender('288eaad1', render)
  })

}


export default __exports__